import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IATMTransactionInquiryFormMeta {
  idBank: FormInputMeta,
  nameBank: FormInputMeta,
  terminalNum: FormInputMeta,
  transactionCode: FormInputMeta,
  status: FormInputMeta,
  processingStatus: FormInputMeta,
  from: FormInputMeta,
  to: FormInputMeta,
  // Schema
  schema: any,
}

const ATMTransactionInquiryFormMeta = {} as IATMTransactionInquiryFormMeta;

ATMTransactionInquiryFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID Banque',
  placeholder: '',
  validation: yup.string().required(),
};

ATMTransactionInquiryFormMeta.nameBank = {
  name: 'nameBank',
  type: 'text',
  label: 'Banque',
  placeholder: '',
  validation: yup.string().required(),
};

ATMTransactionInquiryFormMeta.terminalNum = {
  name: 'terminalNum',
  type: 'text',
  label: 'Terminal Num',
  placeholder: '',
  validation: yup.string().required(),
};

ATMTransactionInquiryFormMeta.transactionCode = {
  name: 'transactionCode',
  type: 'select',
  label: 'Transaction Code',
  options:  [
    {
      label: 'Transaction Code A',
      value: 'a'
    },
    {
      label: 'Transaction Code B',
      value: 'b',
    },
    {
      label: 'Transaction Code C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};

ATMTransactionInquiryFormMeta.status = {
  name: 'status',
  type: 'text',
  label: 'Status',
  placeholder: '',
  validation: yup.string().required(),
};

ATMTransactionInquiryFormMeta.processingStatus = {
  name: 'processingStatus',
  type: 'select',
  label: 'Processing Status',
  options:  [
    {
      label: 'Processing Status A',
      value: 'a'
    },
    {
      label: 'Processing Status B',
      value: 'b',
    },
    {
      label: 'Processing Status C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};

ATMTransactionInquiryFormMeta.from = {
  name: 'from',
  type: 'text',
  label: 'From',
  placeholder: '',
  validation: yup.string().required(),
};

ATMTransactionInquiryFormMeta.to = {
  name: 'to',
  type: 'text',
  label: 'To',
  placeholder: '',
  validation: yup.string().required(),
};



ATMTransactionInquiryFormMeta.schema = yup.object().shape(getValidationSchema(ATMTransactionInquiryFormMeta));

export default ATMTransactionInquiryFormMeta;